var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BaseOfferingDtoBuilder } from './base-offering.dto.builder';
import { OfferingType } from './offering.dto';
var GroupOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(GroupOfferingDtoBuilder, _super);
    function GroupOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupOfferingDtoBuilder.prototype.getOfferingType = function () {
        return OfferingType.GROUP;
    };
    GroupOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign(__assign({}, baseOfferingDto), { schedule: __assign(__assign({}, baseOfferingDto.schedule), { classHours: this.validWeekHours(), durationInMinutes: 10, isDurationVaries: false }) });
    };
    GroupOfferingDtoBuilder.prototype.withDuration = function (durationInMinutes) {
        this.offering.schedule.durationInMinutes = durationInMinutes;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        var groupOffering = this.offering;
        var days = Object.keys(groupOffering.schedule.classHours);
        var staffCounter = 0;
        days
            .map(function (dayName) { return groupOffering.schedule.classHours[dayName]; })
            .forEach(function (day) {
            return day &&
                day.workingHours &&
                day.workingHours.forEach(function (workingHour) {
                    return (workingHour.staffId = staff[staffCounter++ % staff.length].id);
                });
        });
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withMaxParticipants = function (maxParticipantsPerOrder) {
        this.offering.schedulePolicy.maxParticipantsPerOrder =
            maxParticipantsPerOrder;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withClassHours = function (classWeek) {
        this.offering.schedule.classHours = classWeek;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withDurationVaries = function (isDurationVaries) {
        this.offering.schedule.isDurationVaries = isDurationVaries;
    };
    GroupOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return GroupOfferingDtoBuilder;
}(BaseOfferingDtoBuilder));
export { GroupOfferingDtoBuilder };
//# sourceMappingURL=group-offering.dto.builder.js.map